import { Model } from 'core/models';

export class Logo extends Model {
    public id?: number;
    public name?: string;
    public code?: string;
    public icon?: string;
}
